export enum ContentCategory {
	Case,
	Event,
	News,
	Blog,
	Download,
}
